module.exports = __webpack_public_path__ + "static/img/GE-AB.002dc1aa.svg";